// front-page.js
(function ($) {
    "use strict";

    var ENTER_DURATION = 1000; // ms — keep text enter class for animation
    var AUTO_DELAY = 6000; // ms between auto-advances

    function hasSplide() {
        return typeof window.Splide === "function";
    }

    function HeroCarousel(el) {
        this.$el = $(el);
        this.splide = null;
        this.$slides = this.$el.children(".hero-slide");
        this.$category = this.$el.find(".hero-nav__category");
        this.$current = this.$el.find(".hero-nav__current");
        this.total = this.$slides.length;
        this.idx = 0;

        if (!this.total || !hasSplide()) {
            return;
        }

        this._prepareStage();
        this._bind();
        this._mount();
    }

    HeroCarousel.prototype._prepareStage = function () {
        var $root = $('<div class="hero-slides splide"></div>');
        var $track = $('<div class="splide__track"></div>');
        var $list = $('<div class="splide__list"></div>');

        this.$slides.each(function (_, slide) {
            $(slide).addClass("splide__slide").removeClass("is-active is-entering is-exiting").appendTo($list);
        });

        $track.append($list);
        $root.append($track);
        $root.prependTo(this.$el);

        this.splide = new window.Splide($root[0], {
            type: this.total > 1 ? "loop" : "slide",
            perPage: 1,
            arrows: false,
            pagination: false,
            drag: true,
            speed: 700,
            autoplay: this.total > 1,
            interval: AUTO_DELAY,
            pauseOnHover: true,
            pauseOnFocus: false,
            keyboard: false,
            rewind: false,
        });
    };

    HeroCarousel.prototype._mount = function () {
        var self = this;

        this.splide.on("mounted move", function (newIndex) {
            self._onSlideChanged(typeof newIndex === "number" ? newIndex : self.splide.index);
        });

        this.splide.mount();
    };

    HeroCarousel.prototype._onSlideChanged = function (realIndex) {
        var $target = this.$slides.eq(realIndex);

        this.$slides.removeClass("is-active is-entering is-exiting");
        $target.addClass("is-active is-entering");

        this.idx = realIndex;
        this._updateNav();
    };

    HeroCarousel.prototype._bind = function () {
        var self = this;

        this.$el.find(".hero-nav__btn--next").on("click", function () {
            self.splide.go(">>");
        });

        this.$el.find(".hero-nav__btn--prev").on("click", function () {
            self.splide.go("<<");
        });

        this.$el.find(".hero-scroll__btn").on("click", function () {
            self._scrollDown();
        });

        this.$el.on("mouseenter", function () {
            if (self.splide && self.splide.Components.Autoplay) {
                self.splide.Components.Autoplay.pause();
            }
        });

        this.$el.on("mouseleave", function () {
            if (self.total > 1 && self.splide && self.splide.Components.Autoplay) {
                self.splide.Components.Autoplay.play();
            }
        });

        this.$el.attr("tabindex", "0");
        this.$el.on("keydown", function (e) {
            if (e.key === "ArrowRight") {
                self.splide.go(">>");
            }
            if (e.key === "ArrowLeft") {
                self.splide.go("<<");
            }
        });
    };

    HeroCarousel.prototype._updateNav = function () {
        var $slide = $(this.$slides[this.idx]);
        this.$category.text($slide.data("label") || "");
        this.$current.text(String(this.idx + 1).padStart(2, "0"));
    };

    HeroCarousel.prototype._scrollDown = function () {
        var bottom = this.$el.offset().top + this.$el.outerHeight();
        $("html, body").animate({ scrollTop: bottom }, 600);
    };

    // ── Events Carousel ──────────────────────────────────────────

    function EventsCarousel(section) {
        this.$section = $(section);
        this.$carousel = this.$section.find(".ev-carousel");
        this.$cards = this.$section.find(".ev-card");
        this.total = this.$cards.length;
        this.$current = this.$section.find(".ev-nav__current");
        this.$prev = this.$section.find(".ev-nav__btn--prev");
        this.$next = this.$section.find(".ev-nav__btn--next");
        this.splide = null;

        if (!this.total || !hasSplide()) {
            return;
        }

        this._bind();
        this._prepareStage();
        this._mount();
    }

    EventsCarousel.prototype._prepareStage = function () {
        var $existingTrack = this.$carousel.find(".ev-track");
        var $root = $('<div class="ev-splide splide"></div>');
        var $track = $('<div class="splide__track"></div>');
        var $list = $('<div class="ev-track splide__list"></div>');

        this.$cards.each(function (_, card) {
            $(card).addClass("splide__slide").appendTo($list);
        });

        $existingTrack.remove();
        $track.append($list);
        $root.append($track);
        this.$carousel.append($root);

        var perPageLg = parseInt(this.$carousel.data("per-page"), 10) || 4;

        this.splide = new window.Splide($root[0], {
            type: "slide",
            perPage: 1,
            rewind: false,
            arrows: false,
            pagination: false,
            drag: true,
            speed: 450,
            gap: "20px",
            perMove: 1,
            mediaQuery: "min",
            breakpoints: {
                768: { perPage: 2.5 },
                1024: { perPage: 3 },
                1680: { perPage: perPageLg },
            },
        });
    };

    EventsCarousel.prototype._mount = function () {
        var self = this;

        this.splide.on("mounted move resized", function () {
            self._update();
        });

        this.splide.mount();
    };

    EventsCarousel.prototype._update = function () {
        var current = this.splide.index;
        var max = this.splide.length - this.splide.options.perPage;
        max = max < 0 ? 0 : Math.ceil(max);

        this.$current.text(String(current + 1).padStart(2, "0"));
        this.$prev.prop("disabled", current <= 0).toggleClass("is-disabled", current <= 0);
        this.$next.prop("disabled", current >= max).toggleClass("is-disabled", current >= max);
    };

    EventsCarousel.prototype._bind = function () {
        var self = this;

        this.$prev.on("click", function () {
            self.splide.go("<");
        });

        this.$next.on("click", function () {
            self.splide.go(">");
        });
    };

    // ── Testimonials Carousel ─────────────────────────────────────

    function TestimonialsCarousel(section) {
        this.$section = $(section);
        this.$carousel = this.$section.find(".tm-carousel");
        this.$cards = this.$section.find(".tm-card");
        this.total = this.$cards.length;
        this.$current = this.$section.find(".tm-nav__current");
        this.$prev = this.$section.find(".tm-nav__btn--prev");
        this.$next = this.$section.find(".tm-nav__btn--next");
        this.splide = null;

        if (!this.total || !hasSplide()) {
            return;
        }

        this._bind();
        this._prepareStage();
        this._mount();
    }

    TestimonialsCarousel.prototype._prepareStage = function () {
        var $existingTrack = this.$carousel.find(".tm-track");
        var $root = $('<div class="tm-splide splide"></div>');
        var $track = $('<div class="splide__track"></div>');
        var $list = $('<div class="tm-track splide__list"></div>');

        this.$cards.each(function (_, card) {
            $(card).addClass("splide__slide").appendTo($list);
        });

        $existingTrack.remove();
        $track.append($list);
        $root.append($track);
        this.$carousel.append($root);

        this.splide = new window.Splide($root[0], {
            type: "slide",
            perPage: 1,
            rewind: false,
            arrows: false,
            pagination: false,
            drag: true,
            speed: 450,
            gap: "20px",
            perMove: 1,
            mediaQuery: "min",
            breakpoints: {
                768: { perPage: 2.5 },
                1024: { perPage: 3 },
                1680: { perPage: 4 },
            },
        });
    };

    TestimonialsCarousel.prototype._mount = function () {
        var self = this;

        this.splide.on("mounted move resized", function () {
            self._update();
        });

        this.splide.mount();
    };

    TestimonialsCarousel.prototype._update = function () {
        var current = this.splide.index;
        var max = this.splide.length - this.splide.options.perPage;
        max = max < 0 ? 0 : Math.ceil(max);

        this.$current.text(String(current + 1).padStart(2, "0"));
        this.$prev.prop("disabled", current <= 0).toggleClass("is-disabled", current <= 0);
        this.$next.prop("disabled", current >= max).toggleClass("is-disabled", current >= max);
    };

    TestimonialsCarousel.prototype._bind = function () {
        var self = this;

        this.$prev.on("click", function () {
            self.splide.go("<");
        });

        this.$next.on("click", function () {
            self.splide.go(">");
        });
    };

    $(document).ready(function () {
        var $el = $("#hero-carousel");
        if ($el.length) {
            new HeroCarousel($el[0]);
        }

        var $ev = $("#eventos");
        if ($ev.length) {
            new EventsCarousel($ev[0]);
        }

        var $tm = $("#testemunhos");
        if ($tm.length) {
            new TestimonialsCarousel($tm[0]);
        }
    });
})(jQuery);

// page-membership.js
(function () {
    "use strict";

    function initMembershipAccordion() {
        var items = document.querySelectorAll(".mv-accordion__item");
        if (!items.length) return;

        items.forEach(function (item) {
            var header = item.querySelector(".mv-accordion__header");
            if (!header) return;

            header.addEventListener("click", function () {
                var isOpen = item.classList.contains("is-open");
                item.classList.toggle("is-open", !isOpen);
                header.setAttribute("aria-expanded", !isOpen ? "true" : "false");
            });
        });
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", initMembershipAccordion);
    } else {
        initMembershipAccordion();
    }
})();

// Hero video unmute toggle
(function () {
    function initHeroVideoUnmute() {
        var btn = document.querySelector(".mh-bg__unmute");
        if (!btn) return;
        var video = document.querySelector(".mh-bg__video");
        if (!video) return;

        btn.addEventListener("click", function () {
            var isMuted = video.muted;
            video.muted = !isMuted;
            btn.dataset.muted = isMuted ? "0" : "1";
            btn.setAttribute(
                "aria-label",
                isMuted
                    ? btn.getAttribute("data-label-mute") || "Desativar som"
                    : btn.getAttribute("data-label-unmute") || "Ativar som"
            );
        });
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", initHeroVideoUnmute);
    } else {
        initHeroVideoUnmute();
    }
})();

// Hero scroll-to-next-section
(function () {
    function initHeroScroll() {
        var btn = document.querySelector(".mh-scroll__trigger");
        if (!btn) return;

        btn.addEventListener("click", function () {
            var section = btn.closest("section");
            if (!section) return;
            var next = section.nextElementSibling;
            if (!next) return;
            next.scrollIntoView({ behavior: "smooth", block: "start" });
        });
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", initHeroScroll);
    } else {
        initHeroScroll();
    }
})();

// Equipa — tabs + accordion + person modal
(function () {
    "use strict";

    // ── Tabs ────────────────────────────────────────────────────
    function initEquipaTabs() {
        var tabs = document.querySelectorAll(".eq-tab");
        if (!tabs.length) return;

        tabs.forEach(function (tab) {
            tab.addEventListener("click", function () {
                var target = this.getAttribute("data-tab");

                // Update tab states
                tabs.forEach(function (t) {
                    var isActive = t.getAttribute("data-tab") === target;
                    t.classList.toggle("is-active", isActive);
                    t.setAttribute("aria-selected", isActive ? "true" : "false");
                });

                // Update panels
                document.querySelectorAll(".eq-panel").forEach(function (panel) {
                    var id = panel.id; // eq-panel-orgaos | eq-panel-executiva
                    var slug = id.replace("eq-panel-", "");
                    var visible = slug === target;
                    panel.classList.toggle("is-hidden", !visible);
                    if (visible) {
                        panel.removeAttribute("hidden");
                    } else {
                        panel.setAttribute("hidden", "");
                    }
                });
            });
        });
    }

    // ── Equipa accordion (group accordion) ──────────────────────
    function initEquipaAccordion() {
        document.querySelectorAll(".eq-accordion").forEach(function (accordion) {
            var items = accordion.querySelectorAll(".eq-accordion__item");
            items.forEach(function (item) {
                var header = item.querySelector(".eq-accordion__header");
                if (!header) return;

                header.addEventListener("click", function () {
                    var isOpen = item.classList.contains("is-open");
                    item.classList.toggle("is-open", !isOpen);
                    header.setAttribute("aria-expanded", !isOpen ? "true" : "false");
                });
            });
        });
    }

    // ── Person Modal ────────────────────────────────────────────
    function initPersonModal() {
        var overlay = document.getElementById("person-modal");
        if (!overlay) return;

        var panel = overlay.querySelector(".pm-panel");
        var closeBtn = document.getElementById("pm-close");
        var photoEl = document.getElementById("pm-photo");
        var nameEl = document.getElementById("pm-name");
        var roleEl = document.getElementById("pm-role");
        var contactsEl = document.getElementById("pm-contacts");
        var bioEl = document.getElementById("pm-bio");
        var liWrap = document.getElementById("pm-linkedin-wrap");
        var liLink = document.getElementById("pm-linkedin");

        var lastFocus = null;

        function openModal(person) {
            lastFocus = document.activeElement;

            // Populate
            if (person.photo && person.photo.url) {
                photoEl.src = person.photo.url;
                photoEl.alt = person.photo.alt || "";
                photoEl.style.display = "";
            } else {
                photoEl.style.display = "none";
            }

            nameEl.textContent = person.name || "";
            roleEl.textContent = person.role || "";

            contactsEl.innerHTML = "";
            if (person.email) {
                var em = document.createElement("span");
                em.textContent = person.email;
                contactsEl.appendChild(em);
            }
            if (person.phone) {
                var ph = document.createElement("span");
                ph.textContent = person.phone;
                contactsEl.appendChild(ph);
            }

            if (person.linkedin) {
                liLink.href = person.linkedin;
                liWrap.classList.remove("hidden");
            } else {
                liWrap.classList.add("hidden");
            }

            // Bio: preserve newlines as paragraphs
            bioEl.innerHTML = "";
            if (person.bio) {
                bioEl.innerHTML = person.bio;
            }

            overlay.removeAttribute("hidden");
            overlay.classList.add("is-open");
            document.body.style.overflow = "hidden";

            if (panel) panel.focus();
        }

        function closeModal() {
            overlay.classList.remove("is-open");
            overlay.setAttribute("hidden", "");
            document.body.style.overflow = "";
            if (lastFocus) lastFocus.focus();
        }

        // Open on card button click
        document.addEventListener("click", function (e) {
            var btn = e.target.closest("[data-person]");
            if (!btn) return;
            try {
                var person = JSON.parse(btn.getAttribute("data-person"));
                openModal(person);
            } catch (_) {}
        });

        // Close on button
        if (closeBtn) closeBtn.addEventListener("click", closeModal);

        // Close on overlay backdrop click
        overlay.addEventListener("click", function (e) {
            if (e.target === overlay) closeModal();
        });

        // ESC key
        document.addEventListener("keydown", function (e) {
            if (e.key === "Escape" && !overlay.hasAttribute("hidden")) {
                closeModal();
            }
        });
    }

    function init() {
        initEquipaTabs();
        initEquipaAccordion();
        initPersonModal();
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", init);
    } else {
        init();
    }
})();

// Documentos — tabs + pagination
(function () {
    "use strict";

    function initDocumentos() {
        var section = document.getElementById("documentos");
        if (!section) return;

        var tabs = section.querySelectorAll(".dc-tab");
        var panels = section.querySelectorAll(".dc-panel");
        var btnPrev = section.querySelector(".dc-nav__btn--prev");
        var btnNext = section.querySelector(".dc-nav__btn--next");
        var elCurrent = section.querySelector(".dc-nav__current");
        var elTotal = section.querySelector(".dc-nav__total");

        var activePanel = section.querySelector(".dc-panel:not(.is-hidden)");
        var currentPage = 1;

        function pad(n) {
            return n < 10 ? "0" + n : "" + n;
        }

        function updateNav(panel) {
            var totalPages = parseInt(panel.dataset.dcTotalPages, 10) || 1;
            elCurrent.textContent = pad(currentPage);
            elTotal.textContent = pad(totalPages);
            btnPrev.disabled = currentPage <= 1;
            btnNext.disabled = currentPage >= totalPages;
        }

        var animating = false;

        function swapItems(panel, page) {
            panel.querySelectorAll(".dc-item").forEach(function (item) {
                var itemPage = parseInt(item.dataset.dcPage, 10);
                if (itemPage === page) {
                    item.classList.remove("is-hidden");
                    item.removeAttribute("hidden");
                } else {
                    item.classList.add("is-hidden");
                    item.setAttribute("hidden", "");
                }
            });
            currentPage = page;
            updateNav(panel);
        }

        function showPage(panel, page, direction) {
            if (animating) return;
            var list = panel.querySelector(".dc-list");

            if (!list || !direction) {
                swapItems(panel, page);
                return;
            }

            var outClass = direction === "next" ? "dc-slide-out-left" : "dc-slide-out-right";
            var inClass = direction === "next" ? "dc-slide-in-right" : "dc-slide-in-left";

            animating = true;
            list.classList.add(outClass);

            setTimeout(function () {
                list.classList.remove(outClass);
                swapItems(panel, page);
                list.classList.add(inClass);

                setTimeout(function () {
                    list.classList.remove(inClass);
                    animating = false;
                }, 260);
            }, 210);
        }

        function activateTab(slug) {
            tabs.forEach(function (tab) {
                var isMatch = tab.dataset.dcTab === slug;
                tab.classList.toggle("is-active", isMatch);
                tab.setAttribute("aria-selected", isMatch ? "true" : "false");
            });
            panels.forEach(function (panel) {
                var isMatch = panel.dataset.dcPanel === slug;
                panel.classList.toggle("is-hidden", !isMatch);
                if (isMatch) {
                    panel.removeAttribute("hidden");
                    activePanel = panel;
                    showPage(panel, 1, null);
                } else {
                    panel.setAttribute("hidden", "");
                }
            });
        }

        tabs.forEach(function (tab) {
            tab.addEventListener("click", function () {
                activateTab(tab.dataset.dcTab);
            });
        });

        if (btnPrev) {
            btnPrev.addEventListener("click", function () {
                if (currentPage > 1) showPage(activePanel, currentPage - 1, "prev");
            });
        }

        if (btnNext) {
            btnNext.addEventListener("click", function () {
                var totalPages = parseInt(activePanel.dataset.dcTotalPages, 10) || 1;
                if (currentPage < totalPages) showPage(activePanel, currentPage + 1, "next");
            });
        }

        if (activePanel) updateNav(activePanel);
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", initDocumentos);
    } else {
        initDocumentos();
    }
})();

// Stage Grupos accordion
(function () {
    "use strict";

    function initGruposAccordion() {
        document.querySelectorAll(".sg-accordion").forEach(function (accordion) {
            var items = accordion.querySelectorAll(".sg-accordion__item");
            if (!items.length) return;

            items.forEach(function (item) {
                var header = item.querySelector(".sg-accordion__header");
                if (!header) return;

                header.addEventListener("click", function () {
                    var isOpen = item.classList.contains("is-open");
                    item.classList.toggle("is-open", !isOpen);
                    header.setAttribute("aria-expanded", !isOpen ? "true" : "false");
                });
            });
        });
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", initGruposAccordion);
    } else {
        initGruposAccordion();
    }
})();

// Quem é Quem accordion
(function () {
    "use strict";

    function initWiqAccordion() {
        document.querySelectorAll(".wiq-accordion").forEach(function (accordion) {
            var items = accordion.querySelectorAll(".wiq-accordion__item");
            if (!items.length) return;

            items.forEach(function (item) {
                var header = item.querySelector(".wiq-accordion__header");
                if (!header) return;

                header.addEventListener("click", function () {
                    var isOpen = item.classList.contains("is-open");
                    item.classList.toggle("is-open", !isOpen);
                    header.setAttribute("aria-expanded", isOpen ? "false" : "true");
                });
            });
        });
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", initWiqAccordion);
    } else {
        initWiqAccordion();
    }
})();

// Gallery Carousel
(function ($) {
    "use strict";

    function GalleryCarousel(gallery) {
        this.$gallery = $(gallery);
        this.$images = this.$gallery.find("figure.wp-block-image");
        this.total = this.$images.length;
        this.splide = null;

        if (this.total < 2 || typeof window.Splide !== "function") return;

        this._build();
        this._mount();
    }

    GalleryCarousel.prototype._build = function () {
        var self = this;
        var total = this.total;

        var $wrapper = $('<div class="gc-wrapper"></div>');
        var $root = $('<div class="gc-splide splide"></div>');
        var $track = $('<div class="splide__track"></div>');
        var $list = $('<div class="splide__list"></div>');

        this.$images.each(function (_, fig) {
            $('<div class="splide__slide"></div>').append($(fig)).appendTo($list);
        });

        $track.append($list);
        $root.append($track);

        var $nav = $(
            '<div class="gc-nav ev-nav">' +
                '<div class="ev-nav__counter" aria-live="polite" aria-atomic="true">' +
                '<span class="gc-nav__current">01</span>' +
                "<span>/</span>" +
                '<span class="gc-nav__total">' +
                String(total).padStart(2, "0") +
                "</span>" +
                "</div>" +
                '<div class="ev-nav__buttons">' +
                '<button class="ev-nav__btn gc-nav__btn--prev" aria-label="Imagem anterior">' +
                '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
                '<path d="M19 12H5M5 12L12 19M5 12L12 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
                "</svg></button>" +
                '<button class="ev-nav__btn gc-nav__btn--next" aria-label="Próxima imagem">' +
                '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
                '<path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
                "</svg></button>" +
                "</div></div>"
        );

        $wrapper.append($root).append($nav);
        this.$gallery.replaceWith($wrapper);

        this.$current = $nav.find(".gc-nav__current");
        this.$prev = $nav.find(".gc-nav__btn--prev");
        this.$next = $nav.find(".gc-nav__btn--next");

        this.splide = new window.Splide($root[0], {
            type: "slide",
            perPage: 1,
            rewind: false,
            arrows: false,
            pagination: false,
            drag: true,
            speed: 450,
        });
    };

    GalleryCarousel.prototype._mount = function () {
        var self = this;

        this.splide.on("mounted move", function () {
            self._update();
        });

        this.splide.mount();

        this.$prev.on("click", function () {
            self.splide.go("<");
        });

        this.$next.on("click", function () {
            self.splide.go(">");
        });
    };

    GalleryCarousel.prototype._update = function () {
        var current = this.splide.index;
        var max = this.splide.length - 1;

        this.$current.text(String(current + 1).padStart(2, "0"));
        this.$prev.prop("disabled", current <= 0).toggleClass("is-disabled", current <= 0);
        this.$next.prop("disabled", current >= max).toggleClass("is-disabled", current >= max);
    };

    $(document).ready(function () {
        $(".sp-content__data .wp-block-gallery").each(function () {
            new GalleryCarousel(this);
        });
    });
})(jQuery);

// page-associated.js
(function ($) {
    "use strict";

    var cfg = window.hcpAssociated || {};
    var perPage = cfg.perPage || 8;
    var ajaxUrl = cfg.ajaxUrl || "";
    var filterDefaults = cfg.filterDefaults || {};
    var strings = cfg.strings || {};

    // ── Multi-select value helpers ────────────────────────────────────────────
    function getFilterValues(filterName) {
        return $('.select-custom-dropdown[data-filter="' + filterName + '"] .filter-checkbox:checked')
            .map(function () {
                return $(this).val();
            })
            .get();
    }

    function getFilterString(filterName) {
        return getFilterValues(filterName).join(",");
    }

    // ── Checkbox visual state helper ──────────────────────────────────────────
    function applyCheckboxStyle($checkbox, checked) {
        $checkbox
            .closest("label")
            .toggleClass("bg-blue-06", checked)
            .find("span")
            .toggleClass("text-primary font-medium", checked)
            .toggleClass("text-grey-03", !checked);
    }

    // ── Limpar button ──────────────────────────────────────────────────────────
    function updateLimparBtn() {
        var hasFilters =
            $("#search").val() !== "" || getFilterValues("type").length > 0 || getFilterValues("concelho").length > 0;

        var $btn = $(".btn-limpar");
        if (hasFilters) {
            $btn.removeClass("border-grey-05 text-grey-main pointer-events-none opacity-50").addClass(
                "border-primary text-primary"
            );
        } else {
            $btn.removeClass("border-primary text-primary").addClass(
                "border-grey-05 text-grey-main pointer-events-none opacity-50"
            );
        }
    }

    // ── Dropdown label ─────────────────────────────────────────────────────────
    function updateDropdownLabel($dd, defaultLabel) {
        var $checked = $dd.find(".filter-checkbox:checked");
        var count = $checked.length;
        var label;
        if (count === 0) {
            label = defaultLabel;
        } else if (count === 1) {
            label = $checked.first().closest("label").find("span").text().trim();
        } else {
            label = count + " selecionados";
        }
        $dd.find(".select-toggle span").text(label);
    }

    function initDropdownLabels() {
        $(".select-custom-dropdown").each(function () {
            var $dd = $(this);
            updateDropdownLabel($dd, filterDefaults[$dd.data("filter")] || "");
        });
    }

    // ── Dropdown toggle ────────────────────────────────────────────────────────
    function closeAllMenus(exclude) {
        var $menus = $(".select-custom-dropdown .select-menu").not(exclude || null);
        var $chevrons = $(".select-custom-dropdown .select-toggle svg").not(
            exclude ? exclude.closest(".select-custom-dropdown").find("svg") : $()
        );
        $menus.addClass("hidden");
        $chevrons.removeClass("rotate-180");
    }

    // ── AJAX ───────────────────────────────────────────────────────────────────
    var ajaxRequest = null;

    function spinnerHTML() {
        return (
            '<svg fill="hsl(228, 97%, 42%)" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="size-7">' +
            '<path d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,20a9,9,0,1,1,9-9A9,9,0,0,1,12,21Z" transform="translate(12, 12) scale(0)">' +
            '<animateTransform begin="0s" repeatCount="indefinite" attributeName="transform" calcMode="spline" type="translate" dur="1.2s" values="12 12;0 0" keySplines=".52,.6,.25,.99"/>' +
            '<animateTransform begin="0s" repeatCount="indefinite" attributeName="transform" calcMode="spline" additive="sum" type="scale" dur="1.2s" values="0;1" keySplines=".52,.6,.25,.99"/>' +
            '<animate begin="0s" repeatCount="indefinite" attributeName="opacity" calcMode="spline" dur="1.2s" values="1;0" keySplines=".52,.6,.25,.99"/>' +
            "</path>" +
            '<path d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,20a9,9,0,1,1,9-9A9,9,0,0,1,12,21Z" transform="translate(12, 12) scale(0)">' +
            '<animateTransform begin="0.4s" repeatCount="indefinite" attributeName="transform" calcMode="spline" type="translate" dur="1.2s" values="12 12;0 0" keySplines=".52,.6,.25,.99"/>' +
            '<animateTransform begin="0.4s" repeatCount="indefinite" attributeName="transform" calcMode="spline" additive="sum" type="scale" dur="1.2s" values="0;1" keySplines=".52,.6,.25,.99"/>' +
            '<animate begin="0.4s" repeatCount="indefinite" attributeName="opacity" calcMode="spline" dur="1.2s" values="1;0" keySplines=".52,.6,.25,.99"/>' +
            "</path>" +
            '<path d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,20a9,9,0,1,1,9-9A9,9,0,0,1,12,21Z" transform="translate(12, 12) scale(0)">' +
            '<animateTransform begin="0.8s" repeatCount="indefinite" attributeName="transform" calcMode="spline" type="translate" dur="1.2s" values="12 12;0 0" keySplines=".52,.6,.25,.99"/>' +
            '<animateTransform begin="0.8s" repeatCount="indefinite" attributeName="transform" calcMode="spline" additive="sum" type="scale" dur="1.2s" values="0;1" keySplines=".52,.6,.25,.99"/>' +
            '<animate begin="0.8s" repeatCount="indefinite" attributeName="opacity" calcMode="spline" dur="1.2s" values="1;0" keySplines=".52,.6,.25,.99"/>' +
            "</path>" +
            "</svg>"
        );
    }

    function loadAssociated(page) {
        if (ajaxRequest) ajaxRequest.abort();

        var $results = $("#entities-results");
        $results.find("#hcp-loading-overlay").remove();
        $results.css("position", "relative").children().css("opacity", "0.25");
        $results.append(
            '<div id="hcp-loading-overlay" style="position:absolute;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:12px;z-index:10;">' +
                spinnerHTML() +
                '<span class="text-sm text-grey-03">' +
                (strings.loading || "A carregar...") +
                "</span>" +
                "</div>"
        );

        $("#hcp-results-count").addClass("hidden");

        var params = {
            action: "filter_associated",
            nonce: cfg.nonce || "",
            search: $("#search").val(),
            type: getFilterString("type"),
            concelho: getFilterString("concelho"),
            page: page,
            per_page: perPage,
        };

        ajaxRequest = $.ajax({
            url: ajaxUrl,
            type: "POST",
            data: params,
            success: function (res) {
                if (!res.success) {
                    $("#entities-results").hide().html("").fadeIn(200);
                    $("#hcp-results-count").addClass("hidden");
                    return;
                }
                $("#entities-results").hide().html(res.data.html).fadeIn(200);

                var n = parseInt(res.data.total, 10) || 0;
                var $count = $("#hcp-results-count");
                if (n > 0) {
                    var label = n === 1 ? "associado encontrado" : "associados encontrados";
                    $count.html('<strong class="text-grey-01">' + n + "</strong> " + label).removeClass("hidden");
                } else {
                    $count.addClass("hidden");
                }

                var url = new URL(window.location.href);
                params.search ? url.searchParams.set("search", params.search) : url.searchParams.delete("search");
                params.type ? url.searchParams.set("type", params.type) : url.searchParams.delete("type");
                params.concelho
                    ? url.searchParams.set("concelho", params.concelho)
                    : url.searchParams.delete("concelho");
                page > 1 ? url.searchParams.set("paged", page) : url.searchParams.delete("paged");
                window.history.pushState({}, "", url);

                updateLimparBtn();

                var $r = $("#entities-results");
                if ($r.length && $r.offset()) {
                    $("html, body").animate({ scrollTop: $r.offset().top - 100 }, 300);
                }
            },
            error: function (xhr) {
                if (xhr.statusText !== "abort") {
                    $("#entities-results").empty();
                }
            },
        });
    }

    $(document).ready(function () {
        if (!$("#filter-form[data-module='associated']").length) return;

        $(document).on("click", ".select-custom-dropdown .select-toggle", function (e) {
            e.stopPropagation();
            var $dd = $(this).closest(".select-custom-dropdown");
            var $menu = $dd.find(".select-menu");
            var isOpen = !$menu.hasClass("hidden");
            closeAllMenus();
            if (!isOpen) {
                $menu.removeClass("hidden");
                $(this).find("svg").addClass("rotate-180");
            }
        });

        $(document).on("change", ".select-custom-dropdown .filter-checkbox", function () {
            var $cb = $(this);
            var $dd = $cb.closest(".select-custom-dropdown");
            applyCheckboxStyle($cb, $cb.is(":checked"));
            updateDropdownLabel($dd, filterDefaults[$dd.data("filter")] || "");
            updateLimparBtn();
            setTimeout(function () {
                loadAssociated(1);
            }, 50);
        });

        $(document).on("click", ".select-custom-dropdown .select-option-clear", function () {
            var $dd = $(this).closest(".select-custom-dropdown");
            $dd.find(".filter-checkbox")
                .prop("checked", false)
                .each(function () {
                    applyCheckboxStyle($(this), false);
                });
            updateDropdownLabel($dd, filterDefaults[$dd.data("filter")] || "");
            closeAllMenus();
            updateLimparBtn();
            setTimeout(function () {
                loadAssociated(1);
            }, 50);
        });

        $(document).on("click", function (e) {
            if (!$(e.target).closest(".select-custom-dropdown").length) closeAllMenus();
        });

        $("#search").on("keydown", function (e) {
            if (e.key === "Enter") {
                e.preventDefault();
                loadAssociated(1);
            }
        });

        $("#filter-form").on("submit", function (e) {
            e.preventDefault();
            updateLimparBtn();
            loadAssociated(1);
        });

        $(document).on("click", ".ajax-page-btn:not([disabled])", function () {
            loadAssociated(parseInt($(this).data("page"), 10));
        });

        initDropdownLabels();
        updateLimparBtn();
    });
})(jQuery);

// page-diretorio.js
(function ($) {
    "use strict";

    var cfg = window.hcpDiretorio || {};
    var perPage = cfg.perPage || 8;
    var ajaxUrl = cfg.ajaxUrl || "";
    var filterDefaults = cfg.filterDefaults || {};
    var strings = cfg.strings || {};

    // ── Cookie helpers ─────────────────────────────────────────────────────────
    var COOKIE_REGULAR = "hcp_dir_regular";
    var COOKIE_AI = "hcp_dir_ai";
    var COOKIE_DAYS = 15 / (24 * 60);

    function setCookie(name, value, days) {
        var d = new Date();
        d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
        document.cookie = name + "=" + encodeURIComponent(value) + "; expires=" + d.toUTCString() + "; path=/";
    }

    function getCookie(name) {
        var parts = document.cookie.split("; ");
        for (var i = 0; i < parts.length; i++) {
            var idx = parts[i].indexOf("=");
            if (idx > -1 && parts[i].substring(0, idx) === name) {
                return decodeURIComponent(parts[i].substring(idx + 1));
            }
        }
        return null;
    }

    function deleteCookie(name) {
        document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";
    }

    function urlHasFilters() {
        var url = new URL(window.location.href);
        return !!(
            url.searchParams.get("search") ||
            url.searchParams.get("type") ||
            url.searchParams.get("concelho") ||
            url.searchParams.get("segmento") ||
            url.searchParams.get("categoria") ||
            url.searchParams.get("area") ||
            url.searchParams.get("paged")
        );
    }

    function currentPageFromUrl() {
        return parseInt(new URL(window.location.href).searchParams.get("paged"), 10) || 1;
    }

    // Export helpers for ai-search.js
    window.hcpCookies = {
        set: setCookie,
        get: getCookie,
        del: deleteCookie,
        REGULAR: COOKIE_REGULAR,
        AI: COOKIE_AI,
        DAYS: COOKIE_DAYS,
        urlHasFilters: urlHasFilters,
    };

    // ── Multi-select value helpers ────────────────────────────────────────────
    function getFilterValues(filterName) {
        return $('.select-custom-dropdown[data-filter="' + filterName + '"] .filter-checkbox:checked')
            .map(function () {
                return $(this).val();
            })
            .get();
    }

    function getFilterString(filterName) {
        return getFilterValues(filterName).join(",");
    }

    // ── Checkbox visual state helper ──────────────────────────────────────────
    function applyCheckboxStyle($checkbox, checked) {
        $checkbox
            .closest("label")
            .toggleClass("bg-blue-06", checked)
            .find("span")
            .toggleClass("text-primary font-medium", checked)
            .toggleClass("text-grey-03", !checked);
    }

    // ── Save / restore regular-filter state ───────────────────────────────────
    function saveRegularCookie(page) {
        var state = {
            search: $("#search").val(),
            type: getFilterValues("type"),
            concelho: getFilterValues("concelho"),
            segmento: getFilterValues("segmento"),
            categoria: getFilterValues("categoria"),
            area: getFilterValues("area"),
            page: page || 1,
        };
        var hasContent =
            state.search ||
            state.type.length ||
            state.concelho.length ||
            state.segmento.length ||
            state.categoria.length ||
            state.area.length ||
            state.page > 1;
        if (hasContent) {
            setCookie(COOKIE_REGULAR, JSON.stringify(state), COOKIE_DAYS);
        } else {
            deleteCookie(COOKIE_REGULAR);
        }
    }

    function restoreRegularState(state) {
        if (state.search) $("#search").val(state.search);

        ["type", "concelho", "segmento", "categoria", "area"].forEach(function (key) {
            var vals = Array.isArray(state[key]) ? state[key] : state[key] ? [state[key]] : [];
            if (!vals.length) return;
            var $dd = $('.select-custom-dropdown[data-filter="' + key + '"]');
            if (!$dd.length) return;
            $dd.find(".filter-checkbox").each(function () {
                var checked = vals.indexOf($(this).val()) !== -1;
                $(this).prop("checked", checked);
                applyCheckboxStyle($(this), checked);
            });
            updateDropdownLabel($dd, filterDefaults[key] || "");
        });

        updateLimparBtn();
    }

    // ── Limpar button ──────────────────────────────────────────────────────────
    function updateLimparBtn() {
        var hasFilters =
            $("#search").val() !== "" ||
            getFilterValues("type").length > 0 ||
            getFilterValues("concelho").length > 0 ||
            getFilterValues("segmento").length > 0 ||
            getFilterValues("categoria").length > 0 ||
            getFilterValues("area").length > 0;

        var $btn = $("#btn-limpar");
        $btn.toggleClass("active", hasFilters);
    }

    $(document).on("click", "#btn-limpar", function () {
        deleteCookie(COOKIE_REGULAR);
        deleteCookie(COOKIE_AI);
    });

    // ── Dropdown label ─────────────────────────────────────────────────────────
    function updateDropdownLabel($dd, defaultLabel) {
        var $checked = $dd.find(".filter-checkbox:checked");
        var count = $checked.length;
        var label;
        if (count === 0) {
            label = defaultLabel;
        } else if (count === 1) {
            label = $checked.first().closest("label").find("span").text().trim();
        } else {
            label = count + " selecionados";
        }
        $dd.find(".select-toggle span").text(label);
        if (label === defaultLabel) {
            $dd.find(".select-toggle span").removeClass("text-grey-01").addClass("text-grey-03");
        } else {
            $dd.find(".select-toggle span").removeClass("text-grey-03").addClass("text-grey-01");
        }
        updateClearStyle($dd);
    }

    function updateClearStyle($dd) {
        var hasSelection = $dd.find(".filter-checkbox:checked").length > 0;
        $dd.find(".select-option-clear")
            .toggleClass("text-grey-01", hasSelection)
            .toggleClass("text-grey-03", !hasSelection);
    }

    // ── Dropdown init ──────────────────────────────────────────────────────────
    function initDropdownLabels() {
        $(".select-custom-dropdown").each(function () {
            var $dd = $(this);
            updateDropdownLabel($dd, filterDefaults[$dd.data("filter")] || "");
        });
    }

    // ── Dropdown toggle ────────────────────────────────────────────────────────
    function closeAllMenus(exclude) {
        var $menus = $(".select-custom-dropdown .select-menu").not(exclude || null);
        var $chevrons = $(".select-custom-dropdown .select-toggle svg").not(
            exclude ? exclude.closest(".select-custom-dropdown").find("svg") : $()
        );
        $menus.addClass("hidden");
        $chevrons.removeClass("rotate-180");
    }

    // ── AJAX ───────────────────────────────────────────────────────────────────
    var ajaxRequest = null;

    function spinnerHTML() {
        return (
            '<svg fill="hsl(228, 97%, 42%)" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="size-7">' +
            '<path d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,20a9,9,0,1,1,9-9A9,9,0,0,1,12,21Z" transform="translate(12, 12) scale(0)">' +
            '<animateTransform begin="0s" repeatCount="indefinite" attributeName="transform" calcMode="spline" type="translate" dur="1.2s" values="12 12;0 0" keySplines=".52,.6,.25,.99"/>' +
            '<animateTransform begin="0s" repeatCount="indefinite" attributeName="transform" calcMode="spline" additive="sum" type="scale" dur="1.2s" values="0;1" keySplines=".52,.6,.25,.99"/>' +
            '<animate begin="0s" repeatCount="indefinite" attributeName="opacity" calcMode="spline" dur="1.2s" values="1;0" keySplines=".52,.6,.25,.99"/>' +
            "</path>" +
            '<path d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,20a9,9,0,1,1,9-9A9,9,0,0,1,12,21Z" transform="translate(12, 12) scale(0)">' +
            '<animateTransform begin="0.4s" repeatCount="indefinite" attributeName="transform" calcMode="spline" type="translate" dur="1.2s" values="12 12;0 0" keySplines=".52,.6,.25,.99"/>' +
            '<animateTransform begin="0.4s" repeatCount="indefinite" attributeName="transform" calcMode="spline" additive="sum" type="scale" dur="1.2s" values="0;1" keySplines=".52,.6,.25,.99"/>' +
            '<animate begin="0.4s" repeatCount="indefinite" attributeName="opacity" calcMode="spline" dur="1.2s" values="1;0" keySplines=".52,.6,.25,.99"/>' +
            "</path>" +
            '<path d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,20a9,9,0,1,1,9-9A9,9,0,0,1,12,21Z" transform="translate(12, 12) scale(0)">' +
            '<animateTransform begin="0.8s" repeatCount="indefinite" attributeName="transform" calcMode="spline" type="translate" dur="1.2s" values="12 12;0 0" keySplines=".52,.6,.25,.99"/>' +
            '<animateTransform begin="0.8s" repeatCount="indefinite" attributeName="transform" calcMode="spline" additive="sum" type="scale" dur="1.2s" values="0;1" keySplines=".52,.6,.25,.99"/>' +
            '<animate begin="0.8s" repeatCount="indefinite" attributeName="opacity" calcMode="spline" dur="1.2s" values="1;0" keySplines=".52,.6,.25,.99"/>' +
            "</path>" +
            "</svg>"
        );
    }

    function loadEntities(page) {
        if (ajaxRequest) ajaxRequest.abort();

        var $results = $("#entities-results");
        $results.find("#hcp-loading-overlay").remove();
        $results.css("position", "relative").children().css("opacity", "0.25");
        $results.append(
            '<div id="hcp-loading-overlay" style="position:absolute;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:12px;z-index:10;">' +
                spinnerHTML() +
                '<span class="text-sm text-grey-03">' +
                (strings.loading || "A carregar...") +
                "</span>" +
                "</div>"
        );

        $("#hcp-results-count").addClass("hidden");

        var params = {
            action: "filter_entities",
            nonce: cfg.nonce || "",
            search: $("#search").val(),
            type: getFilterString("type"),
            concelho: getFilterString("concelho"),
            segmento: getFilterString("segmento"),
            categoria: getFilterString("categoria"),
            area: getFilterString("area"),
            page: page,
            per_page: perPage,
        };

        ajaxRequest = $.ajax({
            url: ajaxUrl,
            type: "POST",
            data: params,
            success: function (res) {
                if (!res.success) {
                    $("#entities-results").empty();
                    return;
                }
                $("#entities-results").html(res.data.html);

                var n = parseInt(res.data.total, 10) || 0;
                if (n > 0) {
                    var label = n === 1 ? "entidade encontrada" : "entidades encontradas";
                    $("#hcp-results-count")
                        .html('<strong class="text-grey-01">' + n + "</strong> " + label)
                        .removeClass("hidden");
                }

                var url = new URL(window.location.href);
                var keys = {
                    search: params.search,
                    type: params.type,
                    concelho: params.concelho,
                    segmento: params.segmento,
                    categoria: params.categoria,
                    area: params.area,
                };
                $.each(keys, function (k, v) {
                    v ? url.searchParams.set(k, v) : url.searchParams.delete(k);
                });
                page > 1 ? url.searchParams.set("paged", page) : url.searchParams.delete("paged");
                window.history.pushState({}, "", url);

                saveRegularCookie(page);

                var $results = $("#entities-results");
                if ($results.length && $results.offset()) {
                    $("html, body").animate({ scrollTop: $results.offset().top - 100 }, 300);
                }
            },
            error: function (xhr) {
                if (xhr.statusText !== "abort") {
                    $("#entities-results").empty();
                }
            },
        });
    }

    $(document).ready(function () {
        if (!$("#filter-form[data-module='diretorio']").length) return;

        $(document).on("click", "#btn-limpar", function () {
            deleteCookie(COOKIE_REGULAR);
            deleteCookie(COOKIE_AI);
        });

        $(document).on("click", ".select-custom-dropdown .select-toggle", function (e) {
            e.stopPropagation();
            var $dd = $(this).closest(".select-custom-dropdown");
            var $menu = $dd.find(".select-menu");
            var isOpen = !$menu.hasClass("hidden");
            closeAllMenus($menu);
            if (!isOpen) {
                $menu.removeClass("hidden");
                $(this).find("svg").addClass("rotate-180");
            }
        });

        $(document).on("change", ".select-custom-dropdown .filter-checkbox", function () {
            var $cb = $(this);
            var $dd = $cb.closest(".select-custom-dropdown");
            applyCheckboxStyle($cb, $cb.is(":checked"));
            updateDropdownLabel($dd, filterDefaults[$dd.data("filter")] || "");
            updateLimparBtn();
            setTimeout(function () {
                loadEntities(1);
            }, 50);
        });

        $(document).on("click", ".select-custom-dropdown .select-option-clear", function () {
            var $dd = $(this).closest(".select-custom-dropdown");
            $dd.find(".filter-checkbox")
                .prop("checked", false)
                .each(function () {
                    applyCheckboxStyle($(this), false);
                });
            updateDropdownLabel($dd, filterDefaults[$dd.data("filter")] || "");
            closeAllMenus();
            updateLimparBtn();
            setTimeout(function () {
                loadEntities(1);
            }, 50);
        });

        $(document).on("click", ".select-custom-dropdown .select-group-all", function (e) {
            e.stopPropagation();
            var group = $(this).data("group");
            var $dd = $(this).closest(".select-custom-dropdown");
            var $checkboxes = $dd.find('.filter-checkbox[data-group="' + group + '"]');
            var allChecked = $checkboxes.length > 0 && $checkboxes.filter(":checked").length === $checkboxes.length;
            var newState = !allChecked;

            $checkboxes.prop("checked", newState).each(function () {
                applyCheckboxStyle($(this), newState);
            });

            updateDropdownLabel($dd, filterDefaults[$dd.data("filter")] || "");
            updateLimparBtn();
            setTimeout(function () {
                loadEntities(1);
            }, 50);
        });

        $(document).on("click", function (e) {
            if (!$(e.target).closest(".select-custom-dropdown").length) closeAllMenus();
        });

        $("#filter-form").on("submit", function (e) {
            e.preventDefault();
            updateLimparBtn();
            loadEntities(1);
        });

        $(document).on("click", ".ajax-page-btn:not([disabled])", function () {
            loadEntities(parseInt($(this).data("page"), 10));
        });

        window.hcpLoadEntities = loadEntities;

        initDropdownLabels();
        updateLimparBtn();

        var aiAvailable = typeof hcpAISearch !== "undefined" && hcpAISearch.ai_available === "1";
        var aiModeOn = aiAvailable && localStorage.getItem("hcp_ai_mode") !== "0";

        if (urlHasFilters()) {
            saveRegularCookie(currentPageFromUrl());
        } else if (!aiModeOn) {
            var stored = getCookie(COOKIE_REGULAR);
            if (stored) {
                try {
                    var state = JSON.parse(stored);
                    var hasContent =
                        state.search ||
                        (Array.isArray(state.type) && state.type.length) ||
                        (Array.isArray(state.concelho) && state.concelho.length) ||
                        (Array.isArray(state.segmento) && state.segmento.length) ||
                        (Array.isArray(state.categoria) && state.categoria.length) ||
                        (Array.isArray(state.area) && state.area.length) ||
                        (state.page && state.page > 1);
                    if (hasContent) {
                        restoreRegularState(state);
                        loadEntities(state.page || 1);
                    }
                } catch (e) {}
            }
        }
    });
})(jQuery);

// Overview — charts, accordion, PDF download
(function () {
    "use strict";

    var CHART_COLOR = "#10069f";
    var GRID_COLOR = "#d3d7de";
    var TICK_COLOR = "#575e67";
    var chartInstances = {};

    /* ── Utility: load external script once ─────────────────── */
    function loadScript(src, cb) {
        if (document.querySelector('script[src="' + src + '"]')) {
            if (cb) cb();
            return;
        }
        var s = document.createElement("script");
        s.src = src;
        s.onload = cb || null;
        document.head.appendChild(s);
    }

    /* ── Chart init for a single canvas ─────────────────────── */
    function initChart(canvas) {
        if (!canvas || chartInstances[canvas.id]) return;

        var raw = canvas.getAttribute("data-chart");
        if (!raw) return;

        var points;
        try {
            points = JSON.parse(raw);
        } catch (e) {
            return;
        }

        var labels = points.map(function (d) {
            return d.year;
        });
        var values = points.map(function (d) {
            return parseFloat(d.value);
        });

        // Y-axis scale config from data attributes.
        var yStep = parseFloat(canvas.getAttribute("data-y-step"));
        var beginZero = canvas.getAttribute("data-begin-zero") !== "0";
        var yTicks = {
            color: TICK_COLOR,
            font: { family: "NB International Pro", size: 12, weight: "500" },
        };
        if (!isNaN(yStep) && yStep > 0) {
            yTicks.stepSize = yStep;
        }

        chartInstances[canvas.id] = new Chart(canvas, {
            type: "line",
            data: {
                labels: labels,
                datasets: [
                    {
                        data: values,
                        borderColor: CHART_COLOR,
                        backgroundColor: "transparent",
                        borderWidth: 2,
                        pointRadius: 3,
                        pointBackgroundColor: CHART_COLOR,
                        tension: 0.3,
                    },
                ],
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: { display: false },
                    tooltip: {
                        callbacks: {
                            title: function (ctx) {
                                return ctx[0].label;
                            },
                            label: function (ctx) {
                                return ctx.formattedValue;
                            },
                        },
                    },
                },
                scales: {
                    x: {
                        grid: { color: GRID_COLOR },
                        ticks: {
                            color: TICK_COLOR,
                            font: { family: "NB International Pro", size: 12, weight: "500" },
                        },
                    },
                    y: {
                        beginAtZero: beginZero,
                        grid: { color: GRID_COLOR },
                        ticks: yTicks,
                    },
                },
            },
        });
    }

    /* ── Init charts for open accordion body ─────────────────── */
    function initChartsInBody(body) {
        body.querySelectorAll(".ov-chart-canvas").forEach(initChart);
    }

    /* ── Main accordion ─────────────────────────────────────── */
    function initOvAccordion() {
        document.querySelectorAll(".ov-accordion").forEach(function (acc) {
            acc.querySelectorAll(".ov-accordion__item").forEach(function (item) {
                var header = item.querySelector(".ov-accordion__header");
                var body = item.querySelector(".ov-accordion__body");
                var chevron = item.querySelector(".ov-accordion__chevron");
                if (!header || !body) return;

                /* Init charts for the initially-open item */
                if (item.classList.contains("is-open")) {
                    initChartsInBody(body);
                }

                header.addEventListener("click", function () {
                    var isOpen = item.classList.contains("is-open");

                    item.classList.toggle("is-open", !isOpen);
                    header.setAttribute("aria-expanded", isOpen ? "false" : "true");
                    body.classList.toggle("hidden", isOpen);
                    if (chevron) chevron.classList.toggle("rotate-180", isOpen);

                    /* Lazy init charts on open */
                    if (!isOpen) {
                        initChartsInBody(body);
                    }
                });
            });
        });
    }

    /* ── PDF helpers (mirror indicators.js layout) ─────────── */
    function ovLoadImageAsBase64(url, callback) {
        if (!url) {
            callback(null, 0, 0);
            return;
        }
        var img = new Image();
        img.onload = function () {
            var c = document.createElement("canvas");
            c.width = img.naturalWidth || img.width;
            c.height = img.naturalHeight || img.height;
            c.getContext("2d").drawImage(img, 0, 0);
            try {
                callback(c.toDataURL("image/jpeg"), c.width, c.height);
            } catch (e) {
                callback(null, 0, 0);
            }
        };
        img.onerror = function () {
            callback(null, 0, 0);
        };
        img.src = url;
    }

    function ovScaleFontSizes(obj, scale) {
        if (!obj || typeof obj !== "object") return;
        Object.keys(obj).forEach(function (k) {
            var v = obj[k];
            if (k === "font" && v && typeof v === "object" && typeof v.size === "number") {
                v.size = v.size * scale;
            } else if (v && typeof v === "object") {
                ovScaleFontSizes(v, scale);
            }
        });
    }

    function ovRenderHiResChartCanvas(chartInstance, targetW) {
        var src = chartInstance.canvas;
        var srcLogicalW = chartInstance.width || src.width;
        var srcLogicalH = chartInstance.height || src.height;
        var W = targetW;
        var H = Math.round((W * srcLogicalH) / srcLogicalW);
        var scale = W / srcLogicalW;
        var off = document.createElement("canvas");
        off.width = W;
        off.height = H;
        var ctx = off.getContext("2d");
        ctx.fillStyle = "#ffffff";
        ctx.fillRect(0, 0, W, H);

        var cfg = chartInstance.config;
        var clonedOptions = JSON.parse(JSON.stringify(cfg.options || {}));
        clonedOptions.responsive = false;
        clonedOptions.maintainAspectRatio = false;
        clonedOptions.animation = { duration: 0 };
        clonedOptions.devicePixelRatio = 1;
        clonedOptions.plugins = clonedOptions.plugins || {};
        clonedOptions.plugins.tooltip = { enabled: false };
        ovScaleFontSizes(clonedOptions, scale);

        clonedOptions.plugins.legend = clonedOptions.plugins.legend || {};
        clonedOptions.plugins.legend.labels = clonedOptions.plugins.legend.labels || {};
        var lbl = clonedOptions.plugins.legend.labels;
        var origBoxW = typeof lbl.boxWidth === "number" ? lbl.boxWidth : 40;
        var origBoxH = typeof lbl.boxHeight === "number" ? lbl.boxHeight : Chart.defaults.font.size;
        var origPad = typeof lbl.padding === "number" ? lbl.padding : 10;
        lbl.boxWidth = origBoxW * scale;
        lbl.boxHeight = origBoxH * scale;
        lbl.padding = origPad * scale;

        var origDefaultSize = Chart.defaults.font.size;
        Chart.defaults.font.size = origDefaultSize * scale;

        var whiteBgPlugin = {
            id: "ovWhiteBg",
            beforeDraw: function (ch) {
                var c = ch.ctx;
                c.save();
                c.globalCompositeOperation = "destination-over";
                c.fillStyle = "#ffffff";
                c.fillRect(0, 0, ch.width, ch.height);
                c.restore();
            },
        };

        var tempChart;
        var dataUrl;
        try {
            tempChart = new Chart(ctx, {
                type: cfg.type,
                data: cfg.data,
                options: clonedOptions,
                plugins: [whiteBgPlugin],
            });
            dataUrl = off.toDataURL("image/jpeg", 0.85);
        } finally {
            Chart.defaults.font.size = origDefaultSize;
            if (tempChart) tempChart.destroy();
        }
        return { dataUrl: dataUrl, width: W, height: H };
    }

    function ovRenderTextoA(doc, monthYear, methodFileUrl, x, y, maxW, i18n) {
        var fontSize = 7.5;
        var lineH = 4.5;
        var LINK_TEXT = i18n.textoALinkText || "neste link";
        var EMAIL_TEXT = i18n.textoAEmail || "healthbusiness@healthportugal.com";
        var template = i18n.textoABody || "";
        var parts = template.split("%s");
        var para =
            (parts[0] || "") +
            monthYear +
            (parts[1] || "") +
            LINK_TEXT +
            (parts[2] || "") +
            EMAIL_TEXT +
            (parts[3] || "");

        doc.setFontSize(fontSize);
        doc.setTextColor(90, 90, 90);
        var lines = doc.splitTextToSize(para, maxW);
        lines.forEach(function (line) {
            doc.text(line, x, y);
            var idxLink = line.indexOf(LINK_TEXT);
            if (idxLink !== -1 && methodFileUrl) {
                var prefix = line.substring(0, idxLink);
                var prefixW = doc.getTextWidth(prefix);
                var linkW = doc.getTextWidth(LINK_TEXT);
                doc.setTextColor(16, 6, 159);
                doc.textWithLink(LINK_TEXT, x + prefixW, y, { url: methodFileUrl });
                doc.setDrawColor(16, 6, 159);
                doc.setLineWidth(0.15);
                doc.line(x + prefixW, y + 0.6, x + prefixW + linkW, y + 0.6);
                doc.setTextColor(90, 90, 90);
            }
            var idxMail = line.indexOf(EMAIL_TEXT);
            if (idxMail !== -1) {
                var pre = line.substring(0, idxMail);
                var preW = doc.getTextWidth(pre);
                var mailW = doc.getTextWidth(EMAIL_TEXT);
                doc.setTextColor(16, 6, 159);
                doc.textWithLink(EMAIL_TEXT, x + preW, y, { url: "mailto:" + EMAIL_TEXT });
                doc.setDrawColor(16, 6, 159);
                doc.setLineWidth(0.15);
                doc.line(x + preW, y + 0.6, x + preW + mailW, y + 0.6);
                doc.setTextColor(90, 90, 90);
            }
            y += lineH;
        });
        doc.setTextColor(0, 0, 0);
        return y;
    }

    /* ── PDF download (per-chart, indicators layout) ─────── */
    function initOvDownload() {
        var ovCfg = window.hcpOverviewConfig || {};
        var i18n = ovCfg.i18n || {};

        document.querySelectorAll(".ov-download-btn").forEach(function (btn) {
            btn.addEventListener("click", function () {
                var chartId = this.getAttribute("data-chart-id");
                var chartTitle = this.getAttribute("data-chart-title") || "";
                var chartDesc = this.getAttribute("data-chart-desc") || "";
                var chartLegend = this.getAttribute("data-chart-legend") || "";
                var canvas = document.getElementById(chartId);
                var chartInst = chartInstances[chartId];
                if (!canvas || !chartInst) return;

                var raw = canvas.getAttribute("data-chart");
                var points = [];
                try {
                    points = JSON.parse(raw);
                } catch (e) {}

                var jsPDF = window.jspdf && window.jspdf.jsPDF;
                if (!jsPDF) {
                    console.warn("jsPDF not loaded");
                    return;
                }

                btn.setAttribute("disabled", "disabled");
                btn.classList.add("opacity-50");

                ovLoadImageAsBase64(ovCfg.logoUrl || "", function (logoData, logoNatW, logoNatH) {
                    var hi = ovRenderHiResChartCanvas(chartInst, 1600);
                    var imgData = hi.dataUrl;
                    var imgRatio = hi.height / hi.width;

                    var doc = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
                    var pageW = doc.internal.pageSize.getWidth();
                    var pageH = doc.internal.pageSize.getHeight();
                    var marginL = 15;
                    var contentW = pageW - marginL * 2;

                    /* HEADER row: logo left + date right */
                    var headerTop = 5;
                    var logoMaxH = 32;
                    var headerRowH = logoMaxH;
                    var headerMidY = headerTop + headerRowH / 2;

                    if (logoData && logoNatW > 0 && logoNatH > 0) {
                        var logoDisplayW = logoMaxH * (logoNatW / logoNatH);
                        doc.addImage(logoData, "JPEG", marginL, headerTop, logoDisplayW, logoMaxH);
                    }

                    var dateStr = new Date().toLocaleDateString("pt-PT");
                    doc.setFontSize(8);
                    doc.setTextColor(130, 130, 130);
                    doc.text((i18n.pdfDate || "Data de consulta") + ": " + dateStr, pageW - marginL, headerMidY, {
                        align: "right",
                        baseline: "middle",
                    });

                    var curY = headerTop + headerRowH;
                    doc.setDrawColor(210, 210, 210);
                    doc.setLineWidth(0.3);
                    doc.line(marginL, curY, pageW - marginL, curY);
                    curY += 14;

                    /* TITLE */
                    doc.setTextColor(0, 0, 0);
                    doc.setFontSize(18);
                    doc.setFont(undefined, "bold");
                    var titleLines = doc.splitTextToSize(chartTitle, contentW);
                    doc.text(titleLines, marginL, curY);
                    doc.setFont(undefined, "normal");
                    curY += titleLines.length * 8 + 3;

                    /* DESCRIPTION */
                    if (chartDesc) {
                        doc.setFontSize(9);
                        doc.setTextColor(90, 90, 90);
                        var descLines = doc.splitTextToSize(chartDesc, contentW);
                        doc.text(descLines, marginL, curY);
                        doc.setTextColor(0, 0, 0);
                        curY += descLines.length * 5 + 3;
                    }

                    /* CHART (2/3 width) */
                    var chartW = contentW * (2 / 3);
                    var imgH = Math.round(imgRatio * chartW);
                    var availH = pageH - curY - 40;
                    if (imgH > availH) imgH = availH;
                    doc.addImage(imgData, "JPEG", marginL, curY + 2, chartW, imgH);
                    curY += imgH + 8;

                    /* ABOUT / LEGEND text */
                    if (chartLegend) {
                        doc.setFontSize(8);
                        doc.setFont(undefined, "bold");
                        doc.setTextColor(60, 60, 60);
                        doc.text(i18n.pdfAbout || "Sobre este gráfico", marginL, curY);
                        doc.setFont(undefined, "normal");
                        curY += 4.5;
                        var aboutLines = doc.splitTextToSize(chartLegend, contentW);
                        doc.setTextColor(90, 90, 90);
                        doc.text(aboutLines, marginL, curY);
                        doc.setTextColor(0, 0, 0);
                        curY += aboutLines.length * 4.5 + 5;
                    }

                    /* DATA TABLE (year/value) — indicators-style */
                    if (points.length) {
                        var rowH = 6.5;
                        var labelColW = contentW * 0.5;
                        var dataColW = contentW - labelColW;
                        var tableHeaderH = 6;

                        doc.setFontSize(9);
                        doc.setFont(undefined, "bold");
                        doc.setTextColor(0, 0, 0);
                        doc.text(i18n.pdfDataTable || "Tabela de dados", marginL, curY);
                        doc.setFont(undefined, "normal");
                        curY += tableHeaderH;

                        doc.setFillColor(220, 220, 220);
                        doc.rect(marginL, curY, contentW, rowH, "F");
                        doc.setFontSize(8);
                        doc.setFont(undefined, "bold");
                        doc.text(i18n.year || "Ano", marginL + 2, curY + rowH - 1.5);
                        doc.text(i18n.value || "Valor", marginL + labelColW + 2, curY + rowH - 1.5);
                        doc.setFont(undefined, "normal");
                        curY += rowH;

                        points.forEach(function (row, idx) {
                            if (curY + rowH > pageH - 10) {
                                doc.addPage();
                                curY = 15;
                            }
                            if (idx % 2 === 1) {
                                doc.setFillColor(245, 245, 245);
                                doc.rect(marginL, curY, contentW, rowH, "F");
                            }
                            doc.setFontSize(8);
                            doc.text(String(row.year != null ? row.year : ""), marginL + 2, curY + rowH - 1.5);
                            doc.text(
                                String(row.value != null ? row.value : ""),
                                marginL + labelColW + 2,
                                curY + rowH - 1.5
                            );
                            curY += rowH;
                        });
                        curY += 8;
                    }

                    var filename = (chartTitle || "chart").replace(/[^a-z0-9]/gi, "_").toLowerCase() + ".pdf";
                    doc.save(filename);

                    btn.removeAttribute("disabled");
                    btn.classList.remove("opacity-50");
                });
            });
        });
    }

    /* ── Excel export (Download all data) ───────────────────── */
    var ovSpinnerSvg =
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" class="size-6 shrink-0" style="animation:spin 1s linear infinite">' +
        '<circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" stroke-dasharray="31.4" stroke-dashoffset="10" opacity=".25"/>' +
        '<path d="M12 2a10 10 0 0 1 10 10" stroke="currentColor" stroke-width="3" stroke-linecap="round"/>' +
        "</svg>";

    function setOvBtnLoading(btn, loading) {
        if (loading) {
            btn.disabled = true;
            btn.dataset.origHtml = btn.innerHTML;
            btn.innerHTML = ovSpinnerSvg + " A gerar...";
            btn.style.opacity = "0.7";
        } else {
            btn.disabled = false;
            btn.innerHTML = btn.dataset.origHtml || btn.innerHTML;
            btn.style.opacity = "";
        }
    }

    function initOvDownloadAll() {
        var btn = document.getElementById("ov-download-all-btn");
        if (!btn) return;

        var ovCfg = window.hcpOverviewConfig || {};
        var ovI18n = ovCfg.i18n || {};

        btn.addEventListener("click", function () {
            var _allBtn = this;
            setOvBtnLoading(_allBtn, true);
            var _startAll = Date.now();

            if (window.ExcelJS) {
                doExcel();
            } else {
                loadScript("https://cdnjs.cloudflare.com/ajax/libs/exceljs/4.3.0/exceljs.min.js", function () {
                    doExcel();
                });
            }

            function doExcel() {
                var workbook = new window.ExcelJS.Workbook();
                var yearLbl = ovI18n.year || "Ano";
                var valueLbl = ovI18n.value || "Valor";
                var hasSheets = false;

                document.querySelectorAll(".ov-download-btn").forEach(function (dlBtn) {
                    var chartId = dlBtn.getAttribute("data-chart-id");
                    var chartTitle = dlBtn.getAttribute("data-chart-title") || "";
                    var chartDesc = dlBtn.getAttribute("data-chart-desc") || "";
                    var chartLegend = dlBtn.getAttribute("data-chart-legend") || "";
                    var canvas = document.getElementById(chartId);
                    if (!canvas) return;

                    var raw = canvas.getAttribute("data-chart");
                    var points = [];
                    try {
                        points = JSON.parse(raw);
                    } catch (e) {}
                    if (!points.length) return;

                    var sheetName = chartTitle.replace(/[\\\/\*\?\[\]\:]/g, "").substring(0, 31) || "Sheet";
                    var sheet = workbook.addWorksheet(sheetName);
                    hasSheets = true;

                    var sheetHeaderRow = sheet.addRow(["Health Cluster Portugal - Overview do Setor"]);
                    sheetHeaderRow.getCell(1).font = { bold: true, size: 13 };

                    sheet.addRow([]);
                    sheet.addRow([]);

                    var titleRow = sheet.addRow([chartTitle]);
                    titleRow.getCell(1).font = { bold: true, size: 18 };

                    if (chartDesc) sheet.addRow([chartDesc]);
                    if (chartLegend) sheet.addRow([chartLegend]);

                    sheet.addRow([]);
                    sheet.addRow([]);

                    var headerRow = sheet.addRow([yearLbl, valueLbl]);
                    headerRow.eachCell(function (cell) {
                        cell.font = { bold: true };
                    });

                    points.forEach(function (row) {
                        sheet.addRow([row.year != null ? row.year : "", row.value != null ? row.value : ""]);
                    });
                });

                if (!hasSheets) {
                    setOvBtnLoading(_allBtn, false);
                    return;
                }

                workbook.xlsx.writeBuffer().then(function (buffer) {
                    var blob = new Blob([buffer], {
                        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    });
                    var url = URL.createObjectURL(blob);
                    var a = document.createElement("a");
                    a.href = url;
                    a.download = "overview-data.xlsx";
                    document.body.appendChild(a);
                    a.click();
                    setTimeout(function () {
                        document.body.removeChild(a);
                        URL.revokeObjectURL(url);
                    }, 100);
                    var elapsedAll = Date.now() - _startAll;
                    setTimeout(
                        function () {
                            setOvBtnLoading(_allBtn, false);
                        },
                        Math.max(0, 1200 - elapsedAll)
                    );
                });
            }
        });
    }

    /* ── Boot ────────────────────────────────────────────────── */
    function bootOverview() {
        if (!document.querySelector(".ov-accordion, .ov-download-btn, #ov-download-all-btn")) return;

        loadScript("https://cdn.jsdelivr.net/npm/chart.js@4.4.4/dist/chart.umd.min.js", function () {
            initOvAccordion();
        });

        loadScript("https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js", function () {
            initOvDownload();
        });

        initOvDownloadAll();
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", bootOverview);
    } else {
        bootOverview();
    }
})();

// page-projects.js
(function () {
    "use strict";

    // Estado — single-select dropdown
    function initStatusDropdown() {
        var dd = document.getElementById("projects-status-dropdown");
        if (!dd) return;
        var toggle = dd.querySelector(".select-toggle");
        var menu = dd.querySelector(".select-menu");
        var chevron = toggle.querySelector("svg");
        var input = dd.querySelector('input[name="status"]');
        var form = dd.closest("form");

        toggle.addEventListener("click", function (e) {
            e.stopPropagation();
            var willOpen = menu.classList.contains("hidden");
            menu.classList.toggle("hidden");
            chevron.classList.toggle("rotate-180", willOpen);
        });

        dd.querySelectorAll(".select-option").forEach(function (opt) {
            opt.addEventListener("click", function () {
                input.value = opt.getAttribute("data-value") || "";
                form.submit();
            });
        });

        document.addEventListener("click", function (e) {
            if (!dd.contains(e.target)) {
                menu.classList.add("hidden");
                chevron.classList.remove("rotate-180");
            }
        });
    }

    // Temas — multi-select dropdown
    function initTematicaDropdown() {
        var dd = document.getElementById("projects-tematica-dropdown");
        if (!dd) return;
        var toggle = dd.querySelector(".select-toggle");
        var menu = dd.querySelector(".select-menu");
        var chevron = toggle.querySelector("svg");
        var input = dd.querySelector('input[name="tematica"]');
        var form = dd.closest("form");
        var initial = input.value;

        function syncInput() {
            var ids = [];
            dd.querySelectorAll(".tematica-checkbox:checked").forEach(function (cb) {
                ids.push(cb.value);
            });
            input.value = ids.join(",");
        }

        function closeMenu() {
            menu.classList.add("hidden");
            chevron.classList.remove("rotate-180");
            if (input.value !== initial) {
                form.submit();
            }
        }

        toggle.addEventListener("click", function (e) {
            e.stopPropagation();
            if (menu.classList.contains("hidden")) {
                menu.classList.remove("hidden");
                chevron.classList.add("rotate-180");
            } else {
                closeMenu();
            }
        });

        dd.querySelectorAll(".tematica-checkbox").forEach(function (cb) {
            cb.addEventListener("change", syncInput);
        });

        document.addEventListener("click", function (e) {
            if (!dd.contains(e.target) && !menu.classList.contains("hidden")) {
                closeMenu();
            }
        });
    }

    function initProjectsFilters() {
        initStatusDropdown();
        initTematicaDropdown();
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", initProjectsFilters);
    } else {
        initProjectsFilters();
    }
})();
